import React from 'react';
import EventScheduleDatePick from './EventScheduleDatePick/EventScheduleDatePick';
import NewSchedule from './NewSchedule';
const ScheduleCreate = () => {
return( 
    <>
        <EventScheduleDatePick />
        {/* <NewSchedule/> */}

    </>
)};

export default ScheduleCreate;